import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=e2ea8d4e&scoped=true"
import script from "./alarm.vue?vue&type=script&lang=js"
export * from "./alarm.vue?vue&type=script&lang=js"
import style0 from "./alarm.vue?vue&type=style&index=0&id=e2ea8d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ea8d4e",
  null
  
)

export default component.exports